<script>
    import Button from "./Button.svelte";
    function changeControl(key, index, code) {
        const duplicate = Object.values(controlMap).some((arr) =>
            arr.includes(code),
        );
        if (!duplicate) {
            globalThis.controlMap[key][index] = code;
            globalThis.persistControls();
            forceRerender += 1;
        } else {
            Jprompt({
                text: "Cannot assign duplicate key",
                yesText: "Okay",
                forceShow: true,
            });
        }
        // Clear active
        setActive("", 0);
    }
    function keydownListener(event) {
        if (
            ["Control", "Shift", "Alt"].some((modCode) =>
                event.code.includes(modCode),
            )
        ) {
            // Cannot set control mapping to modifier key
            return;
        }
        if (activeKey) {
            if (globalThis.controlMap) {
                // Allow rebinding any key except the Escape key
                // since the Escape key has multiple uses and controls
                // the menu back navigation
                if (event.code == "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    // Escape clears current value
                    changeControl(activeKey, activeIndex, "");
                } else {
                    const { ctrlKey, shiftKey, altKey } = event;
                    const modifiers = `${ctrlKey ? "ctrlKey+" : ""}${
                        shiftKey ? "shiftKey+" : ""
                    }${altKey ? "altKey+" : ""}`;
                    changeControl(
                        activeKey,
                        activeIndex,
                        modifiers + event.code,
                    );
                }
            } else {
                console.error("Cannot set key, no globalThis.controlMap");
            }
        }
    }
    function mousedownListener(event) {
        if (!globalThis.mouseButtonToKeyCode) {
            console.error("mouseButtonToKeyCode is undefined");
        }
        if (event.button !== undefined) {
            const mouseButton = globalThis.mouseButtonToKeyCode(event.button);

            if (activeKey) {
                if (globalThis.controlMap) {
                    if (
                        event.button == 0 ||
                        event.button == 1 ||
                        event.button == 2
                    ) {
                        error = globalThis.i18n("mouseRebindError");
                    } else {
                        changeControl(activeKey, activeIndex, mouseButton);
                    }
                } else {
                    console.error("Cannot set key, no globalThis.controlMap");
                }
            }
        }
    }
    let activeKey = "";
    let activeIndex = 0;
    // forceRerender is needed because this component edits a global variable which svelte stay in
    // sync with like other variables
    let forceRerender = 0;
    function setActive(key, index) {
        activeKey = key;
        activeIndex = index;
        // Reset error
        error = "";
    }
    let error = "";
    function i18nKey(key) {
        const re = /spell(Left)?(Right)?(\d)/;
        const matches = key.match(re);
        if (!matches) {
            return globalThis.i18n(key);
        }
        const [_whole, left, right, number] = matches;
        if (!!left) {
            return globalThis.i18n(["key_spellLeft", number]);
        } else if (!!right) {
            return globalThis.i18n(["key_spellRight", number]);
        } else {
            return globalThis.i18n(["key_spell", number]);
        }
    }
</script>

<h2 class="error-inline">&nbsp;{error}</h2>
<table
    id="keymapping"
    on:keydown={keydownListener}
    on:mousedown={mousedownListener}
>
    {#key forceRerender}
        <tr>
            <td />
            <td>Option 1</td>
            <td>Option 2</td>
            <td>Option 3</td>
        </tr>
        {#each Object.entries(globalThis.controlMap || {}) as [key, controls]}
            <tr>
                <td>
                    {i18nKey(key)}
                </td>
                {#each Object.assign(["", "", ""], controls) as control, index}
                    <td
                        ><button
                            class="reassignKey"
                            on:click={() => setActive(key, index)}
                        >
                            {#if activeKey == key && activeIndex == index}
                                {globalThis.i18n("reassign")}
                            {:else}
                                {(control || "")
                                    .split("Key")
                                    .join("")
                                    .split("Digit")
                                    .join("")
                                    .toLowerCase()}
                            {/if}
                        </button></td
                    >
                {/each}
            </tr>
        {/each}
    {/key}
</table>
<Button
    class="sm"
    text={globalThis.i18n("Reset")}
    on:click={async () => {
        const doReset = await Jprompt({
            text: "Are you sure you want to reset?",
            yesText: "Reset",
            noBtnText: "cancel",
            noBtnKey: "Escape",
            // Ensure it shows up over menu z-index
            forceShow: true,
        });
        if (doReset) {
            globalThis.resetControlMap();
            forceRerender += 1;
            // Clear active
            setActive("", 0);
        }
    }}
></Button>

<style>
    .reassignKey {
        min-width: 200px;
        min-height: 24px;
    }
</style>
